const fr = {
  // Legacy aliases
  add: 'Ajouter', edit: 'Modifier', save: 'Enregistrer', cancel: 'Annuler', delete: 'Supprimer',
  search: 'Rechercher', export: 'Exporter', download: 'Télécharger', signIn: 'Se connecter',
  chassis: 'Châssis', make: 'Marque', model: 'Modèle', year: 'Année', color: 'Couleur',
  mileage: 'Kilométrage', displacement: 'Cylindrée', transmission: 'Transmission',
  port: 'Port', status: 'Statut', price: 'Prix', cost: 'Coût', fobPrice: 'Prix FOB',
  condition: 'État', quantity: 'Quantité', category: 'Catégorie', fitment: 'Compatibilité',
  cutType: 'Type de coupe', sku: 'SKU', name: 'Nom', email: 'E-mail', password: 'Mot de passe',
  phone: 'Téléphone', company: 'Entreprise', country: 'Pays', scan: 'Scanner QR',
  priceQuotes: 'Devis', selectionOrders: 'Commandes de sélection', pricing: 'Tarification',
  vehicles: 'Véhicules', engines: 'Moteurs', parts: 'Pièces', containers: 'Conteneurs',
  customers: 'Clients', requests: 'Demandes', employees: 'Personnel', settings: 'Paramètres',
  dashboard: 'Tableau de bord', inventory: 'Inventaire', myStock: 'Mon stock',
  invoices: 'Factures', payments: 'Paiements', noData: 'Aucune donnée disponible',
  loading: 'Chargement...', totalUnits: 'Total des unités', printQR: 'Imprimer QR',
  whatsAppInquiry: 'Demande WhatsApp', viewDetails: 'Voir les détails',
  staffPortal: 'Portail employés', customerPortal: 'Portail clients',
  invalidCredentials: 'Identifiants invalides',
  recentActivity: 'Activité récente', inventoryValue: "Valeur de l'inventaire",
  inTransit: 'En transit', pendingRequests: 'Demandes en attente',

  // Dashboard
  dash_welcome: 'Bienvenue, {name}',
  dash_good_morning: 'Bonjour', dash_good_afternoon: 'Bon après-midi', dash_good_evening: 'Bonsoir',
  dash_financial_overview: 'aperçu financier',
  dash_units_in_account: 'unités dans votre compte',
  dash_my_shipments: 'Mes expéditions', dash_on_the_way: 'En route', dash_arrived: 'Arrivé',
  dash_no_shipments: 'Aucune expédition active',
  dash_recommended: 'Recommandé pour vous', dash_available_units: 'Unités disponibles',
  dash_no_available: 'Aucune unité disponible.',
  dash_total_fob: 'Valeur FOB totale', dash_total_cost: 'Coût total',
  dash_late_night: 'Bonne nuit', dash_hello: 'Bonjour',
  dash_subtitle: "Aperçu de votre flotte, pièces et expéditions entrantes — mis à jour en temps réel.",
  dash_local_time: 'HEURE LOCALE', dash_status: 'STATUT', dash_all_systems_live: 'Tous les systèmes sont actifs',
  dash_view_recommendations: 'Voir les recommandations', dash_my_stock: 'MON STOCK', dash_in_transit: 'EN TRANSIT',
  dash_units: 'unités', dash_containers: 'conteneurs', dash_browse_more: 'Voir plus',
  dash_track_shipments: 'Suivre les expéditions', dash_browse_inventory_start: "Parcourez l'inventaire pour commencer",
  dash_no_active_shipments: "Aucune expédition active", dash_next_eta: "Prochaine arrivée dans", dash_days: 'jours',
  dash_etas_confirming: "Les dates d'arrivée sont en cours de confirmation", dash_this_week: 'CETTE SEMAINE',
  dash_arriving_soon: 'ARRIVE BIENTÔT', dash_logistics: 'LOGISTIQUE', dash_active_shipments: 'Expéditions actives',
  dash_view_all: 'Voir tout', dash_shipment_empty: "Votre prochaine expédition apparaîtra ici lorsque les unités seront chargées dans un conteneur",
  dash_composition: 'COMPOSITION', dash_stock_breakdown: 'Répartition du stock', dash_no_units_yet: "Pas encore d'unités",
  dash_browse_to_build: "Parcourez l'inventaire pour constituer votre stock",
  dash_for_you: 'POUR VOUS', dash_picked_based: 'Sélectionné selon votre stock', dash_browse_all: 'Tout parcourir',
  dash_picking_units: "Nous sélectionnons des unités pour vous. Revenez bientôt ou parcourez tout l'inventaire",
  dash_view_details: 'Voir les détails', dash_just_arrived: 'VIENT D\'ARRIVER', dash_similar: 'SIMILAIRE AUX VÔTRES',
  dash_today: "Aujourd'hui", dash_tomorrow: 'Demain',
  dash_gross_margin: 'Marge brute', dash_awaiting_pricing: 'En attente de tarification',
  dash_vehicle_fob: 'FOB véhicules', dash_engine_fob: 'FOB moteurs',
  dash_parts_fob: 'FOB pièces', dash_total_freight: 'Coût total du fret',
  dash_fob_by_make: 'FOB par marque', dash_no_priced_vehicles: 'Aucun véhicule tarifé',
  dash_top_units: 'Top 5 unités par FOB', dash_no_priced_units: 'Aucune unité tarifée',
  dash_margin: 'marge', dash_container_breakdown: 'Analyse financière des conteneurs',
  dash_no_containers: 'Aucun conteneur',
  dash_container: 'Conteneur', dash_route: 'Itinéraire', dash_units: 'Unités',
  dash_freight_cost: 'Coût du fret', dash_fob_value: 'Valeur FOB',
  dash_net_after_freight: 'Net après fret',
  dash_receivables: 'Créances', dash_total: 'Total', dash_current: 'Actuel',
  dash_overdue: 'En retard', dash_oldest: 'Le plus ancien', dash_days: 'jours',
  dash_this_month: 'Ce mois-ci', dash_invoiced: 'Facturé', dash_received: 'Reçu',
  dash_avg_margin: 'Marge moyenne', dash_quotes_sent: 'Devis envoyés',
  dash_pending_actions: 'Actions en attente', dash_receipts_verify: 'reçus à vérifier',
  dash_units_pricing: 'unités à tarifer', dash_invoices_overdue: 'factures en retard',
  dash_customer_balances: 'Soldes clients', dash_customer_overview: 'Vue clients',
  dash_top_customers: 'Meilleurs clients (par revenu)',
  dash_attention: 'Attention', dash_no_customer_data: 'Aucune donnée client.',
  dash_no_customers: 'Aucun client', dash_no_activity: 'Aucune activité récente',
  dash_price_quotes: 'Devis', dash_pending: 'En attente',
  dash_in_progress: 'En cours', dash_quoted_week: 'Devisé cette semaine',
  dash_total_units: 'Total des unités',

  // Navigation
  nav_dashboard: 'Tableau de bord', nav_inventory: 'Inventaire', nav_my_stock: 'Mon stock',
  nav_my_selection: 'Ma sélection', nav_containers: 'Conteneurs', nav_requests: 'Demandes',
  nav_invoices: 'Factures', nav_payments: 'Paiements', nav_customers: 'Clients',
  nav_employees: 'Personnel', nav_settings: 'Paramètres', nav_pricing: 'Tarification',
  nav_price_quotes: 'Devis', nav_selection_orders: 'Commandes de sélection',
  nav_tasks: 'Tâches',
  nav_scan: 'Scanner', nav_sign_out: 'Déconnexion',

  // Buttons
  btn_save: 'Enregistrer', btn_cancel: 'Annuler', btn_delete: 'Supprimer', btn_edit: 'Modifier',
  btn_add: 'Ajouter', btn_submit: 'Soumettre', btn_approve: 'Approuver', btn_reject: 'Rejeter',
  btn_download: 'Télécharger', btn_upload: 'Importer', btn_search: 'Rechercher', btn_export: 'Exporter',
  btn_clear: 'Effacer', btn_confirm: 'Confirmer', btn_close: 'Fermer', btn_view: 'Voir',
  btn_remove: 'Retirer', btn_back: 'Retour', btn_next: 'Suivant',
  btn_save_changes: 'Enregistrer les modifications', btn_sign_in: 'Se connecter', btn_contact_us: 'Nous contacter',

  // Login
  login_title: 'BIG STAR', login_subtitle: "Gestion d'exportation de véhicules",
  login_staff_portal: 'Portail employés', login_customer_portal: 'Portail clients',
  login_username: "Nom d'utilisateur", login_email: 'E-mail', login_password: 'Mot de passe',
  login_remember: 'Se souvenir de moi', login_invalid: 'Identifiants invalides',
  login_timeout: 'Session expirée. Reconnectez-vous.',

  // Inventory
  inv_add_to_stock: 'Ajouter à mon stock', inv_in_stock: 'Dans mon stock',
  inv_sold: 'Vendu', inv_available: 'Disponible',
  inv_search_placeholder: 'Rechercher véhicules, pièces, moteurs...',
  inv_no_results: 'Aucun résultat', inv_vehicles: 'Véhicules', inv_engines: 'Moteurs',
  inv_parts: 'Pièces', inv_all: 'Tous', inv_no_data: 'Aucune donnée',
  inv_all_items: 'Tous les éléments', inv_all_status: 'Tous les statuts', inv_all_makes: 'Toutes les marques',
  inv_all_years: 'Toutes les années', inv_all_transmissions: 'Toutes les transmissions',
  inv_all_conditions: 'Tous les états', inv_all_categories: 'Toutes les catégories',
  inv_all_countries: 'Tous les pays', inv_item: 'Élément', inv_details: 'Détails',
  inv_days: 'Jours', inv_show: 'Afficher', inv_request_parts: 'Demander des pièces',
  inv_how_want_vehicle: 'Comment souhaitez-vous ce véhicule ?',
  inv_full_vehicle: 'Véhicule complet', inv_full_vehicle_desc: 'Complet tel quel',
  inv_custom: 'Personnalisé', inv_custom_desc: 'Décrivez votre demande',

  // Detail labels
  detail_make: 'Marque', detail_model: 'Modèle', detail_year: 'Année', detail_chassis: 'Châssis',
  detail_color: 'Couleur', detail_mileage: 'Kilométrage', detail_grade: 'Classe', detail_score: 'Note',
  detail_engine_code: 'Code moteur', detail_transmission: 'Transmission',
  detail_fuel: 'Carburant', detail_steering: 'Direction', detail_drive: 'Transmission',
  detail_condition: 'État', detail_status: 'Statut', detail_price: 'Prix',
  detail_fob: 'Prix FOB', detail_displacement: 'Cylindrée',
  detail_port: 'Port', detail_city: 'Ville', detail_seats: 'Places',
  detail_category: 'Catégorie', detail_fitment: 'Compatibilité', detail_quantity: 'Quantité',
  detail_sku: 'SKU', detail_cut_type: 'Type de coupe', detail_photos: 'Photos',
  detail_notes: 'Notes', detail_location: 'Emplacement', detail_manufacturer: 'Fabricant',
  detail_assign_customer: 'Attribuer au client', detail_assigned_to: 'Attribué à',
  detail_request_parts: 'Demander des pièces de ce véhicule',

  // Statuses
  status_available: 'Disponible', status_assigned: 'Attribué', status_sold: 'Vendu',
  status_shipped: 'Expédié', status_in_transit: 'En transit', status_at_port: 'Au port',
  status_customs: 'Douane', status_delivered: 'Livré', status_japan_yard: 'Parc Japon',
  status_loading: 'Chargement', status_loaded: 'Chargé', status_pending: 'En attente',
  status_approved: 'Approuvé', status_rejected: 'Rejeté', status_planning: 'Planification',
  status_booked: 'Réservé', status_sealed: 'Scellé', status_closed: 'Fermé',

  // Stock
  stock_title: 'Mon stock', stock_available_section: 'Unités disponibles',
  stock_in_review: 'En révision', stock_approved_section: 'Approuvé',
  stock_empty: 'Votre stock est vide.', stock_request_quote: 'Demander un devis',
  stock_quote_requested: 'Devis demandé', stock_my_orders: 'Mes commandes',

  // Selection
  sel_units_selected: '{count} unités sélectionnées', sel_submit: 'Soumettre la sélection finale',
  sel_review_title: 'Vérifiez votre sélection',

  // Containers
  cont_title: 'Conteneurs', cont_no_containers: 'Aucun conteneur pour le moment.',
  cont_destination: 'Destination', cont_eta: "Arrivée estimée", cont_seal: 'Numéro de scellé',
  cont_download_bl: 'Télécharger BL', cont_arrived: 'Conteneur arrivé',
  cont_new_container: 'Nouveau conteneur',

  // Invoices
  invoice_title: 'Factures', invoice_action_required: 'Action requise',
  invoice_total_invoiced: 'Facturé', invoice_total_paid: 'Payé',
  invoice_outstanding: 'En attente', invoice_overdue: 'En retard',
  invoice_upload_receipt: 'Télécharger le reçu', invoice_download_pdf: 'Télécharger PDF',
  invoice_no_invoices: 'Aucune facture', invoice_empty_msg: 'Les factures apparaîtront ici.',

  // Payments
  pay_title: 'Paiements', pay_verified: 'Paiements vérifiés',
  pay_no_verified: 'Aucun paiement vérifié.',
  pay_add: 'Ajouter un paiement', pay_outgoing: 'Paiements sortants',
  pay_no_outgoing: 'Aucun paiement sortant enregistré.',
  pay_verify: 'Vérifier', pay_reject: 'Rejeter',

  // Selection Orders
  selorder_title: 'Commandes de sélection', selorder_no_orders: 'Aucune commande',
  selorder_empty_msg: 'Les commandes des clients apparaîtront ici.',

  // Requests
  req_title: 'Demandes', req_new: 'Nouvelle demande', req_reply: 'Répondre',

  // Settings
  settings_title: 'Paramètres', settings_profile: 'Mon profil',

  // Common UI
  ui_all_customers: 'Tous les clients', ui_export_csv: 'Exporter CSV',
  ui_edit: 'Modifier', ui_delete: 'Supprimer', ui_download: 'Télécharger',

  // Condition
  cond_good: 'Bon', cond_minor_damage: 'Dommage mineur',
  cond_major_damage: 'Dommage majeur', cond_missing_parts: 'Pièces manquantes',

  // Notifications
  notif_title: 'Notifications', notif_no_new: 'Aucune nouvelle notification',

  // Misc
  misc_all_customers: 'Tous les clients', misc_no_data: 'Aucune donnée',
  misc_loading: 'Chargement...', misc_country: 'Pays', misc_currency: 'Devise',
};
export default fr;
